import Component from './components/Login';
import { PATH } from './constants';

export { PATH };
export default Component;
